import {get,post,custorm} from './axios.js';
import {defaultData} from '../assets/js/common.js'

/* ------------------------------------------------- 机构版接口 begin---------------------------------------------------------*/
//论文检测提交 文件提交接口 "/upload_paper"
export function submit_check(datas) {return post('/submit_check', datas)}
//论文列表
export function get_check_list(datas) {return get('/get_check_list', datas)}
//论文报告单篇下载
export function down_report(datas) {return defaultData.baseURL+'/down_report?id='+datas}
//论文报告多篇下载
export function down_report_multi(datas) {return defaultData.baseURL+'/down_report_multi?codes='+datas}

//托管论文提交 文件提交 "/upload_priv_docs"
export function submit_priv_docs(datas) {return post('/submit_priv_docs', datas)}
//获取托管论文列表
export function get_priv_docs_list(datas) {return get('/get_priv_docs_list', datas)}
//删除托管论文
export function del_priv_docs(datas) {return post('/del_priv_docs', datas)}

//登录和注册：获取关注微信公众号二维码
export function create_weixin_concern_qrcode(datas) {return post('/create_weixin_concern_qrcode', datas)}
//注册
export function register(datas) {return post('/register', datas)}
//注册：获取行业分类
export function get_class(datas) {return post('/get_class', datas)}
//注册：上传账号申请（第二步）
export function upload_apply_file(datas) {return custorm('/upload_apply_file', datas)}

//退出
export function logout(datas) {return post('/logout', datas)}
//用户信息获取
export function get_user_info(datas) {return get('/get_user_info', datas)}
//用户信息修改
export function update_uinfo(datas) {return custorm('/update_uinfo', datas)}

//登录：获取页面唯一id
export function get_page_uuid(datas) {return post('/get_page_uuid', datas)}
//登录：前端轮询是否登录
export function ajax_login_verify(datas) {return post('/ajax_login_verify', datas)}
//注册：获取验证码
export function send_sms(datas) {return post('/send_sms', datas)}
//登录：手机号密码登陆
export function login(datas) {return post('/login', datas)}
//登录：是否登陆状态
export function is_login(datas) {return post('/is_login', datas)}
/* ------------------------------------------------- 机构版接口 end---------------------------------------------------------*/


/* ------------------------------------------------- 个人版接口 begin---------------------------------------------------------*/
//获取个人版公众号登录二维码
export function _user_get_login_qrcode(datas) {return post(defaultData.userApiURL+'/create_weixin_concern_qrcode', datas)}
//前端轮询是否登录
export function _user_ajax_login_verify(datas) {return post(defaultData.userApiURL+'/ajax_login_verify', datas)}
//个人版退出
export function _user_logout(datas) {return post(defaultData.userApiURL+'/logout', datas)}
//获取用户信息
export function _user_get_info(datas) {return get(defaultData.userApiURL+'/get_user_info', datas)}
//获取页面唯一id
export function _user_get_page_uuid(datas) {return post(defaultData.userApiURL+'/get_page_uuid', datas)}
//获取检测报告
export function _user_get_check_list(datas) {return get(defaultData.userApiURL+'/get_check_list', datas)}
//下载报告
export function _user_down_report(id, doc_id) {return defaultData.userApiURL+'/down_report?id='+id+'&doc_id='+doc_id}
//下载多篇报告
export function _user_down_report_multi(datas) {return defaultData.userApiURL+'/down_report_multi?codes='+datas}
//查询报告
export function check_report(datas) {return post(defaultData.userApiURL+'/verify', datas)}
//唤起微信非内置浏览器支付
export function _user_vip_pay(datas) {return post(defaultData.userXcxURL+'/awaken_h5_wxpay', datas)}
//h5支付结果轮询
export function _home(datas) {return post(defaultData.userXcxURL+'/home', datas)}
export function _wxpay_h5_result(datas) {return post(defaultData.userXcxURL+'/wxpay_h5_result', datas)}
export function _wxpay_h5_succ(datas) {return post(defaultData.userXcxURL+'/wxpay_h5_succ', datas)}

//唤起微信内置浏览器JSSDK支付
export function _user_vip_pay_jssdk(datas) {return post(defaultData.userXcxURL+'/awaken_builtin_wxpay', datas)}
//获取JSAPI参数
export function _user_get_jssdk(datas) {return post(defaultData.userXcxURL+'/get_wx_jssdk', datas)}
// 微信授权登录
export function _user_wx_login(datas) {return post(defaultData.userXcxURL+'/ajax_wx_login', datas)}
// 获取站点通知
export function _get_site_notice_info(datas) {return post(defaultData.userApiURL+'/get_site_notice_info', datas)}
// 预检查订单号有效性
export function _user_check_tid_before(datas) {return post(defaultData.userApiURL+'/check_tid_before', datas)}

// 获取VIP购买列表
export function _user_get_vip_goods_list(datas) {return post(defaultData.userApiURL+'/get_buy_list', datas)}
// 获取支付链接
export function _user_get_pay_url(datas) {return post(defaultData.userApiURL+'/get_pay_url', datas)}
// 获取支付结果
export function _user_get_pay_result(datas) {return post(defaultData.userApiURL+'/get_pay_result', datas)}

// 校验表单
export function _user_submit_check(datas) {return post(defaultData.userApiURL+'/submit_check', datas)}
// 提交论文表单
export function _user_submit_paper(datas) {return post(defaultData.userApiURL+'/submit', datas)}

// 提交学术集
export function _user_upload_docs(datas) {return custorm(defaultData.userApiURL+'/upload_docs', datas)}
// 获取学术集
export function _user_get_docs_list(datas) {return get(defaultData.userApiURL+'/get_docs_list', datas)}

// 获取积分商品
export function get_integral_goods_list(datas) {return post(defaultData.userApiURL+'/get_integral_goods_list', datas)};
// 获取支付结果
export function get_pay_result(datas) {return post(defaultData.userApiURL+'/get_pay_result', datas)};
/* ------------------------------------------------- 个人版接口 end---------------------------------------------------------*/

// 获取免费查重券
export function get_user_coupon(datas) {return post(defaultData.userApiURL+'/get_user_coupon', datas)}

//关注公众号获取查重券
export function _user_lunwen_wx_login(datas) {return post(defaultData.userApiURL+'/ajax_wx_login', datas)}
export function _get_gz_free_coupon(datas) {return post(defaultData.userApiURL+'/get_gz_free_coupon', datas)}
export function _get_gz_user_coupon(datas) {return post(defaultData.userApiURL+'/get_gz_user_coupon', datas)}
export function _user_del_report(datas) {return post(defaultData.userApiURL+'/del_report', datas)}

//下载学校院系申请书/风景图
export function _down_school_media(datas) {return defaultData.schoolApiURL+'/down_school_media?type='+datas}
export function is_user_login(datas) {return post(defaultData.userApiURL+'/is_login', datas)}
// 获取所有下级单位
export function get_unit_list(datas) {return post(defaultData.schoolApiURL+'/get_unit_list', datas)}



// WEBPACK FOOTER //
// ./src/api/index.js